import * as Url from "./Utils/UrlUtil";
import * as Layout from "./Utils/LayoutUtil";
import Modal from "./_bootstrapModalExtensions";
import * as GAUtil from './_google_analytics';
import { ShowHelper } from "./_helpers";
import Interfaces from "./_interfaces";
import { initUnreadMessageCount } from "./_layout";

let noticeActions: Interfaces.NoticeActions = {
    Check: () => {
        let incomingGrid: MVCxClientGridView = window['MessageList'];

        if (incomingGrid) {
            if (incomingGrid.GetSelectedKeysOnPage().length > 0) {
                noticeActions.Enable('#NoticeTabTrio_C0');
            } else {
                noticeActions.Disable('#NoticeTabTrio_C0');
            }
        }

        let outGoingGrid: MVCxClientGridView = window['OutgoingList'];

        if (outGoingGrid) {
            if (outGoingGrid.GetSelectedKeysOnPage().length > 0) {
                noticeActions.Enable('#NoticeTabTrio_C1');
            } else {
                noticeActions.Disable('#NoticeTabTrio_C1');
            }
        }
    },

    Enable: (inview: HTMLElement) => {
        inview = inview ? inview : noticeViews.ActiveView;
        $(inview).find('.gridaction').removeClass('disabled');
    },

    Disable: (inview: HTMLElement) => {
        inview = inview ? inview : noticeViews.ActiveView;
        $(inview).find('.gridaction').addClass('disabled');
    }
};

let noticeViews: Interfaces.NoticeViews = {
    ActiveList: null,
    ActiveView: null,
    Set: (viewType: string) => {
        //bejövő/kimenő - összes
        if (viewType === 'AllByUserIncoming' || viewType === 'AllByUserOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.archive').show();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
        //bejövő/kimenő - olvasatlan
        else if (viewType === 'NotReadByUserIncoming' || viewType === 'NotReadByUserOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.unread').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
        //bejövő/kimenő - olvasott
        else if (viewType === 'ReadedByUserIncoming' || viewType === 'ReadedByUserOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.read').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
        //bejövő/kimenő - archivált
        else if (viewType === 'ArchivedByUserIncoming' || viewType === 'ArchivedByUserOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.archive').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').show();
        }
        //hatósági bejövő/kimenő összes
        else if (viewType === 'AllByOfficeIncoming' || viewType === 'AllByOfficeOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.archive').show();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
        //hatósági bejövő/kimenő olvasatlan
        else if (viewType === 'NotReadByOfficeIncoming' || viewType === 'NotReadByOfficeOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.unread').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
        //hatósági bejövő/kimenő olvasott
        else if (viewType === 'ReadedByOfficeIncoming' || viewType === 'ReadedByOfficeOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.read').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
        //hatósági bejövő/kimenő archivált
        else if (viewType === 'ArchivedByOfficeIncoming' || viewType === 'ArchivedByOfficeOutgoing') {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.archive').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').show();
        }
        else {
            $(noticeViews.ActiveView).find('.gridaction').show();
            $(noticeViews.ActiveView).find('.gridaction.archive').hide();
            $(noticeViews.ActiveView).find('.gridaction.reactivate').hide();
        }
    }
};

export function OnNoticeInit() {
    setNoticeActionIcons();
}

function setNoticeActionIcons() {
    noticeViews.ActiveView = $('#NoticeTabTrio_C0:visible, #NoticeTabTrio_C1:visible, #NoticeTabTrio_C2:visible')[0];
    noticeViews.ActiveList = $('#NoticeTabTrio_C0:visible').length > 0 ? 'MessageList' : 'OutgoingList';
}

export function OnIncomingMessageListPartialBeginCallback(s, e: MVCxClientBeginCallbackEventArgs) {
    handleNoticeBeginCallback(s, e, '#NoticeBaseFilterIncoming');
}

export function OnOutgoingMessageListPartialBeginCallback(s, e: MVCxClientBeginCallbackEventArgs) {
    handleNoticeBeginCallback(s, e, '#NoticeBaseFilterOutgoing');
}

function handleNoticeBeginCallback(s, e: MVCxClientBeginCallbackEventArgs, baseFilterSelector: string) {
    let baseFilter: string = $(baseFilterSelector).val() as string;

    e.customArgs['baseFilterId'] = baseFilter;

    sendSearchAnalytics(s);
}

function sendSearchAnalytics(s) {
    // A keresett kifejezés
    let filterExpression: string = s.filterHelper.savedSearchEditorValue_beforeCallback as string;

    GAUtil.SendEventToAnalytics('Keresés', 'Értesítések', filterExpression);
}

export function NoticeOnRowClick(s, e: ASPxClientGridViewRowClickEventArgs) {
    let keys: string = s.GetRowKey(e.visibleIndex);
    let keyArray: string[] = keys.split('|');
    let noticeType: string = keyArray[1];
    let viewType: string = $("#NoticeBaseFilterIncoming").val() as string;

    let urlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.OpenNotice"];
    let url: string = Url.createUrlFromTemplate(urlTemplate, { baseFilterId: viewType, rowKeys: keys });

    if (noticeType === 'Share' || noticeType === 'Process' || noticeType === 'Filing' || noticeType === 'Feedback') {
        location.href = url;
    }
}

export function NoticeEndCallbackIncoming() {
    let val: string = $('#NoticeBaseFilterIncoming').val() as string;
    noticeEndCallbackCommon(val);
};

export function NoticeEndCallbackOutgoing() {
    let val: string = $('#NoticeBaseFilterOutgoing').val() as string;
    noticeEndCallbackCommon(val);
};

function noticeEndCallbackCommon(val: string) {
    noticeViews.Set(val);
    noticeActions.Disable();
    noticeActions.Check();

    window.ETDR_RD.adjustTables();
};

export function OnNoticeTabChanged(s: ASPxClientTabControl, e: ASPxClientTabControlTabEventArgs) {
    if (!Layout.IsOnGreenSide()) {
        switch (e.tab.name) {
            case 'incoming': ShowHelper('Helper_16', false);
                break;
            case 'outgoing': ShowHelper('Helper_16', false);
                break;
        }
    }

    noticeViews.ActiveView = $('#NoticeTabTrio_C0:visible, #NoticeTabTrio_C1:visible, #NoticeTabTrio_C2:visible')[0];
    noticeViews.ActiveList = $('#NoticeTabTrio_C0:visible').length > 0 ? 'MessageList' : 'OutgoingList';
};

export function SetMessageProperty(event: JQuery.ClickEvent) {
    let property: string = $(event.target).data('property') as string;
    let isvalue: boolean = $(event.target).data('value') as boolean;
    let className: string = '.';

    if (property === 'IsRead') {
        if (isvalue) {
            className += 'read';
        } else {
            className += 'unread';
        }
    } else if (property === 'IsArchived') {
        if (isvalue) {
            className += 'archive';
        } else {
            className += 'reactivate';
        }
    }

    var list = noticeViews.ActiveList === 'MessageList' ? window['MessageList'] : window['OutgoingList'];

    if (!$(noticeViews.ActiveView).find(className).hasClass('disabled')) {
        let selectedRows: string[] = list.GetSelectedKeysOnPage();

        if (selectedRows.length > 1) {
            let text: string = `Biztosan elvégzi a műveletet a kijelölt ${selectedRows.length} db elemen?`;
            Modal.showConfirmationWindowAsync(
                text,
                'Megerősítés',
                () => {
                    sendRequest(property, isvalue, selectedRows);
                    noticeActions.Check();
                },
                () => {
                    noticeActions.Check();
                },
                "Igen",
                "Nem");
        } else {
            sendRequest(property, isvalue, selectedRows);
        }
    }
};

function sendRequest(property, isvalue, selectedRows) {
    $.ajax({
        method: 'POST',
        url: window.ETDR_RD.appConfig['UrlAction.SetMessageProperty'],
        dataType: 'json',
        traditional: true,
        data: {
            property: property,
            isValue: isvalue,
            messageIds: selectedRows
        },
        success: function () {

            let grid: MVCxClientGridView = noticeViews.ActiveList === 'MessageList' ? window['MessageList'] as MVCxClientGridView : window['OutgoingList'] as MVCxClientGridView;
            grid.Refresh();

            initUnreadMessageCount();
        }
    });
};

export function OnNoticeSelectionChanged(s: MVCxClientGridView, e: ASPxClientGridViewFocusEventArgs) {
    noticeActions.Check();
}

jQuery(() => {
    $(document).on('click', '.notice-page-action-icon', (event: JQuery.ClickEvent) => { SetMessageProperty(event); });
});
